// Safe localStorage: some browsers block storage inside embedded previews
export const storage = {
  get(k) {
    try { return window.localStorage.getItem(k); } catch { return null; }
  },
  set(k, v) {
    try { window.localStorage.setItem(k, v); } catch { /* storage unavailable */ }
  },
  remove(k) {
    try { window.localStorage.removeItem(k); } catch { /* storage unavailable */ }
  },
};
